var routes = [{
  path: '/de',
  breadcrumb: 'Home',
  title: 'Truck-Jobs'
}, {
  path: '/de/fahrer',
  breadcrumb: 'Arbeitnehmer',
  title: 'LKW-Fahrer finden hier Job : Truck-Jobs'
}, {
  path: '/de/arbeitgeber',
  breadcrumb: 'Arbeitgeber',
  title: 'LKW- und Kraftfahrer finden : Truck-Jobs'
}, {
  path: '/de/datenschutz',
  breadcrumb: 'Datenschutz',
  title: 'Datenschutz­rechtliche Einwilligungs­erklärung  : Truck-Jobs'
}, {
  path: '/de/impressum',
  breadcrumb: 'Impressum',
  title: 'Impressum  : Truck-Jobs'
}, {
  path: '/de/faq',
  breadcrumb: 'FAQ',
  title: 'FAQ : Truck-Jobs'
}, {
  path: '/de/nutzungs­bedingungen',
  breadcrumb: 'Nutzungs­bedingungen',
  title: 'Nutzungs­bedingungen : Truck-Jobs'
}, {
  path: '/de/fahrer/jobsuche',
  breadcrumb: 'Jobsuche',
  title: 'Job suchen mit Truck-Jobs'
}, {
  path: '/lkw-jobs',
  breadcrumb: 'LKW Jobs Übersicht',
  title: 'LKW Jobs Übersicht'
}, {
  path: '/de/wissen',
  breadcrumb: 'News',
  title: 'News Übersicht zum Thema Jobsuche für LKW Fahrer'
}, {
  path: '/de/erfahrungen',
  breadcrumb: 'Truck-Jobs Erfahrungen',
  title: 'Meinungen und Erfahrungen zum Thema Truck-Jobs'
}];
export default routes;